import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import Portal from '../Portal/index.esm.js';
import FocusLock from '../FocusLock/index.esm.js';
import Transition from '../Transition/index.esm.js';
import { ModalContextProvider } from './context.esm.js';
import { useModal } from './use-modal.esm.js';
export { default as ModalBody } from './ModalBody/index.esm.js';
export { default as ModalCloseButton } from './ModalCloseButton/index.esm.js';
export { default as ModalContent } from './ModalContent/index.esm.js';
export { default as ModalFooter } from './ModalFooter/index.esm.js';
export { default as ModalHeader } from './ModalHeader/index.esm.js';
export { default as ModalOverlay } from './ModalOverlay/index.esm.js';
export { default as ModalTitle } from './ModalTitle/index.esm.js';

function Modal(props) {
  var children = props.children,
      initialFocusRef = props.initialFocusRef,
      finalFocusRef = props.finalFocusRef,
      _props$returnFocusOnC = props.returnFocusOnClose,
      returnFocusOnClose = _props$returnFocusOnC === void 0 ? true : _props$returnFocusOnC,
      open = props.open,
      _props$size = props.size,
      size = _props$size === void 0 ? 'max-w-md' : _props$size,
      _props$trapFocus = props.trapFocus,
      trapFocus = _props$trapFocus === void 0 ? true : _props$trapFocus,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
      getContainer = props.getContainer;

  var context = _extends({}, useModal(props), {
    size: size
  });

  if (!open) return null;
  var dialogRef = context.dialogRef;
  return React__default.createElement(ModalContextProvider, {
    value: context
  }, React__default.createElement(Portal, {
    getContainer: getContainer
  }, React__default.createElement(Transition, {
    appear: true,
    show: open
  }, React__default.createElement(FocusLock, {
    autoFocus: autoFocus,
    disabled: !trapFocus,
    initialFocusRef: initialFocusRef,
    finalFocusRef: finalFocusRef,
    restoreFocus: returnFocusOnClose,
    contentRef: dialogRef
  }, children))));
}

export default Modal;
//# sourceMappingURL=index.esm.js.map
